import { render, staticRenderFns } from "./CollectCourseDetail.vue?vue&type=template&id=497c1a82&scoped=true&"
import script from "./CollectCourseDetail.vue?vue&type=script&lang=js&"
export * from "./CollectCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectCourseDetail.vue?vue&type=style&index=0&id=497c1a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c1a82",
  null
  
)

export default component.exports